module.exports = __webpack_public_path__ + "static/media/Knight-horse012_1c.36bf5c28.svg";